import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/**
 * Download reading as PNG image
 */
export const downloadAsImage = async (elementId, filename = 'bitarot-reading.png') => {
  try {
    const element = document.getElementById(elementId);
    if (!element) {
      console.error('Element not found:', elementId);
      return;
    }

    // Capture the element as canvas
    const canvas = await html2canvas(element, {
      backgroundColor: '#0a0e27',
      scale: 2, // Higher quality
      logging: false,
      useCORS: true,
      allowTaint: true,
    });

    // Convert to blob and download
    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = filename;
      link.href = url;
      link.click();
      URL.revokeObjectURL(url);
    });

    return true;
  } catch (error) {
    console.error('Error downloading as image:', error);
    return false;
  }
};

/**
 * Download reading as PDF
 */
export const downloadAsPDF = async (elementId, filename = 'bitarot-reading.pdf') => {
  try {
    const element = document.getElementById(elementId);
    if (!element) {
      console.error('Element not found:', elementId);
      return;
    }

    // Capture the element as canvas
    const canvas = await html2canvas(element, {
      backgroundColor: '#0a0e27',
      scale: 2,
      logging: false,
      useCORS: true,
      allowTaint: true,
    });

    const imgData = canvas.toDataURL('image/png');
    
    // Calculate PDF dimensions to fit the content
    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
    const pdf = new jsPDF('p', 'mm', 'a4');
    
    let heightLeft = imgHeight;
    let position = 0;

    // Add first page
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Add additional pages if content is longer than one page
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(filename);
    return true;
  } catch (error) {
    console.error('Error downloading as PDF:', error);
    return false;
  }
};

/**
 * Share reading (uses Web Share API if available, falls back to download)
 */
export const shareReading = async (elementId, title = 'My Bitarot Reading') => {
  try {
    const element = document.getElementById(elementId);
    if (!element) {
      console.error('Element not found:', elementId);
      return;
    }

    // Capture as canvas
    const canvas = await html2canvas(element, {
      backgroundColor: '#0a0e27',
      scale: 2,
      logging: false,
      useCORS: true,
      allowTaint: true,
    });

    // Convert to blob
    const blob = await new Promise((resolve) => canvas.toBlob(resolve));
    
    // Try Web Share API
    if (navigator.share && navigator.canShare) {
      const file = new File([blob], 'bitarot-reading.png', { type: 'image/png' });
      
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: title,
          text: 'Check out my Bitarot reading! 🔮',
          files: [file],
        });
        return true;
      }
    }
    
    // Fallback to download
    await downloadAsImage(elementId);
    return true;
  } catch (error) {
    console.error('Error sharing reading:', error);
    // Fallback to download on error
    await downloadAsImage(elementId);
    return false;
  }
};
